module.exports = __webpack_public_path__ + "img/ux.3ed6886c.svg";